import React from 'react'
import PhoneWhiteIcon from '../../../assets/images/front/svg/phone-white.svg'
import EnvelopeIcon from '../../../assets/images/front/svg/envelope-white.svg'
import FacebookIcon from '../../../assets/images/front/svg/facebook-white.svg'
import InstagramIcon from '../../../assets/images/front/svg/instagram-white.svg'
import YouTubeIcon from '../../../assets/images/front/svg/youtube-white.svg'

const Contacts: React.FC = () => {
  return (
    <>
      <div className="container py-6 md:py-0 md:pt-12 mx-4 px-4">
        <div className="grid grid-cols-10 gap-4">
          <div className="col-span-5 md:col-span-2">
            <a
              href="tel:+420737577089"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={PhoneWhiteIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">+420 737 577 089</span>
            </a>
          </div>
          <div className="col-span-5 md:col-span-2">
            <a
              href="mailto:info@dohlavy.cz"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={EnvelopeIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">info@dohlavy.cz</span>
            </a>
          </div>
          <div className="col-span-5 md:col-span-2">
            <a
              href="https://www.facebook.com/Dohlavy"
              target="_blank"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={FacebookIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">Dohlavy</span>
            </a>
          </div>
          <div className="col-span-5 md:col-span-2">
            <a
              href="https://www.instagram.com/dohlavy_online/"
              target="_blank"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={InstagramIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">@dohlavy_online</span>
            </a>
          </div>
          <div className="col-span-5 md:col-span-2">
            <a
              href="https://www.youtube.com/@Dohlavy_online"
              target="_blank"
              className="group flex flex-col items-center justify-center text-xl"
            >
              <div className="block w-[92px] h-[92px] rounded-full bg-[#00A0E3] group-hover:bg-[#0183BA] flex items-center justify-center mb-3 transition-colors duration-300">
                <img src={YouTubeIcon} alt="" />
              </div>

              <span className="text-[#0183BA]">@dohlavy_online</span>
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contacts
